import { closureMonthsStore } from '@/fsd/entities/closure-months/model/store/closureMonthsStore/closureMonthsStore';
import { useEffect } from 'react';

export const useLoadClosureMonths = () => {
  useEffect(() => {
    closureMonthsStore.fetchAllClosureMonths();
  }, []);
};
